import classes from './App.css';
import Main from './pages/main/Main';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import About from './pages/about/About';
import Wrapper from './pages/wrapper/Wrapper';
import 'bootstrap/dist/css/bootstrap.min.css';
import Archive from "./pages/archive/Archive";
import Events from "./pages/events/Events";
import Preachings from "./pages/preachings/Preachings";
import {Helmet} from 'react-helmet';
import Profile from "./pages/profile/Profile";
import "react-toastify/dist/ReactToastify.css";
import {Toaster} from "sonner";

const Layout = () => {
    const isTest = process.env.REACT_APP_NODE === "test";

    return (
        <div className={classes.main}>
            <Toaster position="bottom-center" duration={2000} richColors closeButton />
            <Helmet>
                {isTest && (
                    <meta name="robots" content="noindex, nofollow" />
                )}
            </Helmet>

            {isTest && (
                <h1 className={`text-center`}>Тестовая версия сайта!!!</h1>
            )}
            <Wrapper/>
        </div>
    );
}

function App() {

    const router = createBrowserRouter([
        {
            path: "/",
            element: <Layout/>,
            children: [
                {
                    path: "/",
                    element: <Main/>,
                },
                {
                    path: "/profile",
                    element: <Profile/>,
                },
                {
                    path: "/about",
                    element: <About/>
                },
                {
                    path: "/archive",
                    element: <Archive/>,
                },
                {
                    path: "/events",
                    element: <Events/>,
                },
                {
                    path: "/preachings",
                    element: <Preachings/>,
                }
            ]
        },
    ]);

    return <RouterProvider router={router}/>;
}

export default App;
